import React from "react";

const NXEditPen = ({ className }: { className?: string }) => {
  return (
    <svg  className={className} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4287_3309)">
    <path d="M0.719004 9.39099L4.609 13.281C4.74963 13.4214 4.94025 13.5003 5.139 13.5003C5.33775 13.5003 5.52838 13.4214 5.669 13.281L13.389 5.56099C13.4278 5.52391 13.4578 5.47862 13.4768 5.42844C13.4959 5.37827 13.5034 5.32447 13.499 5.27099L12.909 1.44099C12.9042 1.34972 12.8658 1.26347 12.8012 1.19885C12.7365 1.13422 12.6503 1.0958 12.559 1.09099L8.729 0.50099C8.67552 0.496551 8.62172 0.504124 8.57155 0.523157C8.52137 0.542189 8.47608 0.572199 8.439 0.61099L0.719004 8.33099C0.578554 8.47161 0.499664 8.66224 0.499664 8.86099C0.499664 9.05974 0.578554 9.25036 0.719004 9.39099Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.88904 4.61096C9.6129 4.61096 9.38904 4.3871 9.38904 4.11096C9.38904 3.83482 9.6129 3.61096 9.88904 3.61096C10.1652 3.61096 10.389 3.83482 10.389 4.11096C10.389 4.3871 10.1652 4.61096 9.88904 4.61096Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_4287_3309">
    <rect width="14" height="14" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    
  );
};

export default NXEditPen;
